import { Component } from '@angular/core';

@Component({
  selector: 'app-not-logged-layout',
  templateUrl: './not-logged-layout.component.html',
  styleUrl: './not-logged-layout.component.scss'
})
export class NotLoggedLayoutComponent {

}
